import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Box, CircularProgress } from '@mui/material';

interface SubscriptionRouteProps {
  children: React.ReactElement;
}

/**
 * Route wrapper that requires an active subscription for Client role
 * Admins bypass this check
 */
export default function SubscriptionRoute({
  children,
}: SubscriptionRouteProps) {
  const { loading, userRole, hasActiveSubscription } = useAuth();

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Admins don't need active subscription
  if (userRole === 'Admin') {
    return children;
  }

  // Clients need active subscription
  if (userRole === 'Client' && !hasActiveSubscription) {
    // Redirect to subscription management page
    return <Navigate to="/my-subscription" replace />;
  }

  return children;
}
